define('OutSystems/ClientRuntime/Format',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ApplicationFormatInfo = exports.NumberFormatInfo = exports.DateTimeFormatInfo = void 0;
    var cachedFormats = {};
    function parseComponentFormat(format, parts) {
        var cachedFormat = cachedFormats[format];
        if (typeof cachedFormat !== "undefined") {
            return cachedFormat;
        }
        var separator = format.replace(new RegExp("[" + parts.join("") + "]", "gi"), "").substr(0, 1);
        var partData = [];
        var i;
        for (i = 0; i < parts.length; i++) {
            partData.push({
                index: format.toLowerCase().indexOf(parts[i]),
                character: parts[i],
                length: format.replace(new RegExp("[^" + parts[i] + "]", "gi"), "").length,
            });
        }
        partData.sort(function (x, y) { return (x.index < y.index ? -1 : 1); });
        var parsedComponent = {
            format: format,
            separator: separator,
            parts: {},
            regExp: null,
        };
        parsedComponent.regExp = "^";
        for (i = 0; i < partData.length; i++) {
            var length_1 = "";
            switch (partData[i].character.toLowerCase()) {
                case "h":
                case "m":
                case "d":
                    length_1 = "1,2";
                    break;
                case "s":
                    parsedComponent.regExp += "(?" + separator;
                    length_1 = "1,2";
                    break;
                default:
                    length_1 = partData[i].length;
            }
            if (i > 0) {
                parsedComponent.regExp += "\\" + separator;
            }
            parsedComponent.regExp += "([0-9]{" + length_1 + "}" + ")" + (partData[i].character === "s" ? ")?" : "");
            parsedComponent.parts[partData[i].character + "Index"] = i;
            parsedComponent.parts[partData[i].character + "Format"] = format.slice(partData[i].index, partData[i].index + partData[i].length);
        }
        parsedComponent.regExp += "$";
        cachedFormats[format] = parsedComponent;
        return parsedComponent;
    }
    function parseDateFormat(dateFormat) {
        return parseComponentFormat(dateFormat, ["y", "m", "d"]);
    }
    function parseTimeFormat(timeFormat) {
        return parseComponentFormat(timeFormat, ["h", "m", "s"]);
    }
    var DateTimeFormatInfo = (function () {
        function DateTimeFormatInfo(dateFormat, timeFormat, dateTimeSeparator, tzInfo) {
            if (dateTimeSeparator === void 0) { dateTimeSeparator = " "; }
            if (tzInfo === void 0) { tzInfo = ""; }
            this.dateFmt = parseDateFormat(dateFormat);
            this.timeFmt = parseTimeFormat(timeFormat);
            this.dateTimeSep = dateTimeSeparator;
            this.tzInformation = tzInfo;
        }
        DateTimeFormatInfo.getDayName = function (day) {
            return DateTimeFormatInfo.DayNames[day];
        };
        DateTimeFormatInfo.getShortDayName = function (day) {
            return DateTimeFormatInfo.DayNames[day].slice(0, 3);
        };
        DateTimeFormatInfo.getMonthName = function (monthNumber) {
            return DateTimeFormatInfo.MonthNames[monthNumber - 1];
        };
        DateTimeFormatInfo.getShortMonthName = function (monthNumber) {
            return DateTimeFormatInfo.MonthNames[monthNumber - 1].slice(0, 3);
        };
        DateTimeFormatInfo.get12HourNotation = function (hour) {
            return hour < 12 ? "AM" : "PM";
        };
        DateTimeFormatInfo.getTimezoneInformationFull = function (tzo) {
            var timezoneSignal = DateTimeFormatInfo.getTimezoneSignal(-tzo);
            tzo = Math.abs(tzo);
            return (timezoneSignal +
                DateTimeFormatInfo.padLeadingZeros(Math.floor(tzo / 60).toString(), 2) +
                ":" +
                DateTimeFormatInfo.padLeadingZeros(Math.floor(tzo % 60).toString(), 2));
        };
        DateTimeFormatInfo.getTimezoneInformationHoursFull = function (tzo) {
            var timezoneSignal = DateTimeFormatInfo.getTimezoneSignal(-tzo);
            tzo = Math.abs(tzo);
            return timezoneSignal + DateTimeFormatInfo.padLeadingZeros(Math.floor(tzo / 60).toString(), 2);
        };
        DateTimeFormatInfo.getTimezoneInformationHoursShort = function (tzo) {
            var timezoneSignal = DateTimeFormatInfo.getTimezoneSignal(-tzo);
            tzo = Math.abs(tzo);
            return timezoneSignal + Math.floor(tzo / 60);
        };
        DateTimeFormatInfo.getTimezoneSignal = function (tzOffset) {
            return tzOffset < 0 ? "-" : "+";
        };
        DateTimeFormatInfo.padLeadingZeros = function (text, length) {
            var result = text || "";
            while (result.length < length) {
                result = "0" + result;
            }
            return result;
        };
        DateTimeFormatInfo.removeTrailingZeros = function (text) {
            var result = text || "";
            return result.replace(/0+$/gm, "");
        };
        Object.defineProperty(DateTimeFormatInfo.prototype, "dateFormat", {
            get: function () {
                return this.dateFmt.format;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "timeFormat", {
            get: function () {
                return this.timeFmt.format;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "dateTimeFormat", {
            get: function () {
                return this.dateFmt.format + this.dateTimeSeparator + this.timeFmt.format;
            },
            enumerable: false,
            configurable: true
        });
        DateTimeFormatInfo.prototype.getRegExpForDate = function () {
            return new RegExp(this.dateFmt.regExp, "i");
        };
        Object.defineProperty(DateTimeFormatInfo.prototype, "yearIndexForDate", {
            get: function () {
                return this.dateFmt.parts.yIndex;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "monthIndexForDate", {
            get: function () {
                return this.dateFmt.parts.mIndex;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "dayIndexForDate", {
            get: function () {
                return this.dateFmt.parts.dIndex;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "yearFormatForDate", {
            get: function () {
                return this.dateFmt.parts.yFormat;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "monthFormatForDate", {
            get: function () {
                return this.dateFmt.parts.mFormat;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "dayFormatForDate", {
            get: function () {
                return this.dateFmt.parts.dFormat;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "dateSeparator", {
            get: function () {
                return this.dateFmt.separator;
            },
            enumerable: false,
            configurable: true
        });
        DateTimeFormatInfo.prototype.getRegExpForTime = function () {
            return new RegExp(this.timeFmt.regExp, "i");
        };
        Object.defineProperty(DateTimeFormatInfo.prototype, "hoursIndexForTime", {
            get: function () {
                return this.timeFmt.parts.hIndex;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "minutesIndexForTime", {
            get: function () {
                return this.timeFmt.parts.mIndex;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "secondsIndexForTime", {
            get: function () {
                return this.timeFmt.parts.sIndex;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "timeSeparator", {
            get: function () {
                return this.timeFmt.separator;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "dateTimeSeparator", {
            get: function () {
                return this.dateTimeSep;
            },
            enumerable: false,
            configurable: true
        });
        DateTimeFormatInfo.prototype.getRegExpForDateTime = function () {
            return new RegExp(this.dateFmt.regExp.substring(0, this.dateFmt.regExp.length - 1) +
                this.dateTimeSeparator +
                this.timeFmt.regExp.substring(1, this.timeFmt.regExp.length - 1) +
                this.tzInformation +
                "$", "i");
        };
        Object.defineProperty(DateTimeFormatInfo.prototype, "yearIndexForDateTime", {
            get: function () {
                return this.dateFmt.parts.yIndex;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "monthIndexForDateTime", {
            get: function () {
                return this.dateFmt.parts.mIndex;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "dayIndexForDateTime", {
            get: function () {
                return this.dateFmt.parts.dIndex;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "hoursIndexForDateTime", {
            get: function () {
                return this.timeFmt.parts.hIndex + 3;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "hoursFormatForTime", {
            get: function () {
                return this.timeFmt.parts.hFormat;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "minutesFormatForTime", {
            get: function () {
                return this.timeFmt.parts.mFormat;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "secondsFormatForTime", {
            get: function () {
                return this.timeFmt.parts.sFormat;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "minutesIndexForDateTime", {
            get: function () {
                return this.timeFmt.parts.mIndex + 3;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeFormatInfo.prototype, "secondsIndexForDateTime", {
            get: function () {
                return this.timeFmt.parts.sIndex + 3;
            },
            enumerable: false,
            configurable: true
        });
        DateTimeFormatInfo.DayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        DateTimeFormatInfo.MonthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        return DateTimeFormatInfo;
    }());
    exports.DateTimeFormatInfo = DateTimeFormatInfo;
    var NumberFormatInfo = (function () {
        function NumberFormatInfo(decimalSeparator, groupSeparator) {
            this.decimalSep = decimalSeparator;
            this.groupSep = groupSeparator;
            this.integerFmtRegExp = null;
            this.decimalFmtRegExp = null;
            this.generateFormatRegExps(decimalSeparator, groupSeparator);
        }
        NumberFormatInfo.prototype.generateFormatRegExps = function (decimalSeparator, groupSeparator) {
            var decimalSeparatorRx = "\\" + decimalSeparator;
            var integerPartRx = "(([0-9]{1,3}(" + (!!groupSeparator ? "\\" + groupSeparator : "") + "[0-9]{3})*)|([0-9]+))";
            var decimalPartRx = "[0-9]+";
            this.integerFmtRegExp = "^[-]?" + integerPartRx + "$";
            this.decimalFmtRegExp =
                "^[-]?((" +
                    integerPartRx +
                    "(" +
                    decimalSeparatorRx +
                    "(" +
                    decimalPartRx +
                    ")?)?)|((" +
                    integerPartRx +
                    ")?" +
                    decimalSeparatorRx +
                    decimalPartRx +
                    "))$";
        };
        Object.defineProperty(NumberFormatInfo.prototype, "decimalSeparator", {
            get: function () {
                return this.decimalSep;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(NumberFormatInfo.prototype, "groupSeparator", {
            get: function () {
                return this.groupSep;
            },
            enumerable: false,
            configurable: true
        });
        NumberFormatInfo.prototype.getRegExpForInteger = function () {
            return new RegExp(this.integerFmtRegExp, "i");
        };
        NumberFormatInfo.prototype.getRegExpForDecimal = function () {
            return new RegExp(this.decimalFmtRegExp, "i");
        };
        NumberFormatInfo.prototype.getRegExpForJSNumber = function () {
            return new RegExp("^-?(?:0|[1-9]\\d*)(?:\\.\\d+)?(?:[eE][+-]?\\d+)?$", "i");
        };
        return NumberFormatInfo;
    }());
    exports.NumberFormatInfo = NumberFormatInfo;
    var ApplicationFormatInfo = (function () {
        function ApplicationFormatInfo(dateTimeFormatInfo, numberFormatInfo) {
            this.defaultDateTimeFormats = [
                new DateTimeFormatInfo("yyyy-MM-dd", "HH:mm:ss"),
                new DateTimeFormatInfo("yyyy-MM-dd", "HH:mm:ss"),
                new DateTimeFormatInfo("yyyy/MM/dd", "HH:mm:ss"),
                new DateTimeFormatInfo("yyyy.MM.dd", "HH:mm:ss"),
            ];
            this.defaultNumberFmt = numberFormatInfo;
            this.currentNumberFmt = numberFormatInfo;
            this.defaultDateTimeFormats[0] = dateTimeFormatInfo;
        }
        Object.defineProperty(ApplicationFormatInfo.prototype, "defaultDateTimeFormat", {
            get: function () {
                return this.defaultDateTimeFormats[0];
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ApplicationFormatInfo.prototype, "dateTimeFormats", {
            get: function () {
                return this.defaultDateTimeFormats;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ApplicationFormatInfo.prototype, "dateTimeFormat", {
            set: function (format) {
                this.defaultDateTimeFormats[0] = format;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ApplicationFormatInfo.prototype, "defaultNumberFormat", {
            get: function () {
                return this.defaultNumberFmt;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ApplicationFormatInfo.prototype, "numberFormat", {
            get: function () {
                return this.currentNumberFmt;
            },
            set: function (format) {
                this.currentNumberFmt = format;
            },
            enumerable: false,
            configurable: true
        });
        return ApplicationFormatInfo;
    }());
    exports.ApplicationFormatInfo = ApplicationFormatInfo;
});
//# sourceMappingURL=Format.js.map;
